const translations = {
    boundary: 'Boundary',
    incompleteBoundary: 'You must have at least one apply zone',
    noApply: 'No-Apply',
    noEntry: 'No-Entry'
};

export default translations;
